import { GameSession } from '../../../../../shared/model/game-session';

export interface EventDaySchedule {
  date: Date;
  dateLabel: string;
  sessions: GameSession[];
}

export function generateEventDaysRange(startDate: string | Date, endDate?: string | Date): Date[] {
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);

  if (!endDate) {
    return [start];
  }

  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);

  if (isNaN(end.getTime()) || end < start) {
    return [start];
  }

  const days: Date[] = [];
  const current = new Date(start);

  while (current <= end) {
    days.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return days;
}

export function groupSessionsByEventDays(
  eventDays: Date[],
  sessions: GameSession[],
  canManage: boolean
): EventDaySchedule[] {
  const grouped = eventDays.map((date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    const daySessions = sessions
      .filter((session) => {
        const sessionDate = new Date(session.startTime);
        return (
          sessionDate.getFullYear() === year &&
          sessionDate.getMonth() === month &&
          sessionDate.getDate() === day
        );
      })
      .sort((a, b) => a.startTime - b.startTime);

    return {
      date,
      dateLabel: date.toISOString().split('T')[0], // Placeholder per formattazione, eventualmente usare formatDateRangePipe o utils
      sessions: daySessions,
    };
  });

  if (!canManage) {
    return grouped.filter((group) => group.sessions.length > 0);
  }

  return grouped;
}

export function calculateNextAvailableStartTime(
  date: Date,
  existingSessionsOnDate: GameSession[],
  defaultDurationMinutes: number = 150
): string {
  if (!existingSessionsOnDate || existingSessionsOnDate.length === 0) {
    return '10:00';
  }

  let maxEndTime = 0;
  for (const session of existingSessionsOnDate) {
    const endTime = session.endTime || session.startTime + defaultDurationMinutes * 60000;
    if (endTime > maxEndTime) {
      maxEndTime = endTime;
    }
  }

  const maxEndDate = new Date(maxEndTime);
  const hours = maxEndDate.getHours().toString().padStart(2, '0');
  const minutes = maxEndDate.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

export function combineDateAndTimeToTimestamp(date: Date, timeStr: string): number {
  const [hoursStr, minutesStr] = timeStr.split(':');
  const result = new Date(date);
  result.setHours(parseInt(hoursStr, 10), parseInt(minutesStr, 10), 0, 0);
  return result.getTime();
}
